import React from "react";
import { UserMessage } from "../../../styles";
import { MessageText } from "./styled";

export default function MessageUser({ text }: { text: string }) {
  return (
    <UserMessage>
      <MessageText>{text}</MessageText>
    </UserMessage>
  );
}
